import {
  TableCell,
  TableRow,
  Chip,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import { Link } from 'react-router';
import { ArrowSquareOut, Shuffle } from '@phosphor-icons/react';
import { Api } from '../../api';
import { format } from 'date-fns';
import { Model } from '../../models';

export default function AssignedUserRow({
  user,
  onReassignClick,
  hideReassign,
}: {
  user: Api.User.V_ClientList;
  onReassignClick: () => void;
  hideReassign?: boolean;
}) {
  return (
    <TableRow
      sx={{
        '&:hover': {
          backgroundColor: 'action.hover',
        },
      }}
    >
      <TableCell>{user.user.name || user.user.email}</TableCell>
      <TableCell>{user.user.email}</TableCell>
      <TableCell>
        <Box display="flex" alignItems="center" gap={1}>
          <Chip
            label={Model.ProgramProgress.getStatusLabel(user.programProgress)}
            color={Model.ProgramProgress.getStatusColor(user.programProgress)}
          />
          {user.programProgress.currentWeekNumber && (
            <Typography variant="body2" color="textSecondary">
              {user.programProgress.currentWeekNumber} Week
            </Typography>
          )}
        </Box>
      </TableCell>
      <TableCell>
        <Box>
          <div>{user.appointmentHeld ?? 0} held</div>
          <div>{user.appointmentScheduled ?? 0} scheduled</div>
        </Box>
      </TableCell>
      <TableCell>{format(user.user.registeredAt, 'd MMM yyyy')}</TableCell>
      <TableCell>
        <Box display="flex" alignItems="center" gap={1}>
          <IconButton
            component={Link}
            to={`/users/${user.user.id}/account-details`}
            sx={{ color: 'primary.main' }}
          >
            <ArrowSquareOut size={24} />
          </IconButton>
          {!hideReassign && (
            <IconButton
              onClick={onReassignClick}
              sx={{ color: 'text.secondary' }}
            >
              <Shuffle size={24} />
            </IconButton>
          )}
        </Box>
      </TableCell>
    </TableRow>
  );
}
